'use strict';

import $ from 'jquery';
import { roundDecimal } from '../modules/billable-utils';
import UserValidator from '../modules/user_validator';
import StripeForm from '../modules/stripe_form';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#design-package')) {
      $(document).on('click', '.design-package__package-button', (e) => {
        const $button = $(e.target);
        const designPackageId = $button.data().designPackageId;

        $('.design-package__package-button')
          .removeClass('design-package__package-button--selected')
          .text('Choose Package');
        $button.addClass('design-package__package-button--selected').text('Selected Package');

        $('.covered-rooms').hide();
        $(`.covered-rooms[data-design-package-id=${designPackageId}]`).show();

        if ($(window).width() >= 599) {
          $('body,html').animate(
            {
              scrollTop:
                $(`.covered-rooms[data-design-package-id=${designPackageId}]`).position().top - 20,
            },
            600
          );
        } else {
          document
            .getElementById(`edit_design_package_${designPackageId}`)
            .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
        }

        return false;
      });
    }
    if ($('body').is('#design-package') || $('body').is('#design-packages-copy-link')) {
      const xhrChoosePackageModal = (packageParams) => {
        const teamSlug = $('meta[name="team-slug"]').attr('content');
        let url = `/design-packages/${teamSlug}/${packageParams.designPackageId}/xhr_choose_package`;
        if ('data' in packageParams) {
          url += `?${packageParams.data}`;
        }
        $.get(url).done((data) =>
          $(data)
            .appendTo('body')
            .modal(packageParams.unClosableModalParams || {})
        );
      };

      if ($('body').is('#design-packages-copy-link')) {
        const packageId = $('meta[name="package-id"]').attr('content');

        if (packageId !== undefined) {
          xhrChoosePackageModal({
            designPackageId: packageId,
            unClosableModalParams: { escapeClose: false, clickClose: false, showClose: false },
          });
        }
      }

      $(document).ready(() => {
        $('.show-more-design-packages-button').on('click', () => {
          $('.design-package-details__list-item--more').show();
          $('.show-more-design-packages-button').addClass('hide');
          $('.show-less-design-packages-button').removeClass('hide');
        });
        $('.show-less-design-packages-button').on('click', () => {
          $('.design-package-details__list-item--more').hide();
          $('.show-less-design-packages-button').addClass('hide');
          $('.show-more-design-packages-button').removeClass('hide');
        });
      });

      $(document).on('click', '.p-button--proceed-to-payment', (e) => {
        const $package = $(e.target).closest('.covered-rooms');
        const id = $package.data().designPackageId;
        const data = $package.find('form').serialize();

        xhrChoosePackageModal({ designPackageId: id, data });

        return false;
      });

      $(document).on('click', '.design-package__proceed-to-payment', (e) => {
        xhrChoosePackageModal({ designPackageId: $(e.target).data().designPackageId });

        return false;
      });

      const updateProceedButton = ($package) => {
        const $button = $package.find('.p-button--proceed-to-payment');
        const coveredRoomsNumber = $package.data().roomsNumber;
        const roomsNumber = $package
          .find('.field--covered-rooms-qty')
          .toArray()
          .reduce((total, element) => {
            return total + Number(element.value);
          }, 0);

        if (coveredRoomsNumber) {
          $button.prop('disabled', roomsNumber !== coveredRoomsNumber);
        } else if (roomsNumber === 0) {
          $button.attr('disabled', 'disabled');
        } else {
          const price = $package.data().price;
          const total = roundDecimal(roomsNumber * price).toFixed(2);

          $button.prop('disabled', total === 0);
        }
      };

      $(document).on('change', '.selection-list__input--package', (e) => {
        const $checkbox = $(e.target);
        const checked = $checkbox.is(':checked');
        const $package = $checkbox.closest('.covered-rooms');
        const coveredRoomsNumber = $package.data().roomsNumber;
        const roomsNumber = $package
          .find('.field--covered-rooms-qty')
          .toArray()
          .reduce((total, element) => {
            return total + Number(element.value);
          }, 0);

        if (coveredRoomsNumber && checked) {
          if (roomsNumber === coveredRoomsNumber) {
            $checkbox.prop('checked', false);
            return false;
          }
        }

        const $qtyControls = $checkbox.siblings('.rooms-qty-controls');
        $qtyControls.toggle();

        const $input = $qtyControls.find('input');
        $input.val(checked ? 1 : 0);

        updateProceedButton($package);
      });

      $(document).on(
        'click',
        '.rooms-qty-controls__increase, .rooms-qty-controls__decrease',
        (e) => {
          const $control = $(e.target);
          const $package = $control.closest('.covered-rooms');
          const $input = $control.closest('.rooms-qty-controls').find('input');
          const coveredRoomsNumber = $package.data().roomsNumber;
          const roomsNumber = $package
            .find('.field--covered-rooms-qty')
            .toArray()
            .reduce((total, element) => {
              return total + Number(element.value);
            }, 0);

          let val = Number($input.val());

          if ($control.hasClass('rooms-qty-controls__increase')) {
            if (coveredRoomsNumber) {
              if (roomsNumber === coveredRoomsNumber) {
                return false;
              }
            }

            val += 1;
          } else if ($control.hasClass('rooms-qty-controls__decrease')) {
            val -= 1;
          }
          if (val < 1) {
            val = 1;
          }

          $input.val(val);

          updateProceedButton($package);
        }
      );

      $(document).on('click', '.choose-package__tab-link', function () {
        const kind = $(this).data().kind;

        $('.choose-package__user-register').hide();
        $('.choose-package__user-login').hide();
        $(`.choose-package__user-${kind}`).show();

        return false;
      });

      $(document).on($.modal.OPEN, '.modal--choose-package', () => {
        const stripeConnectId = $('#stripe_connect_id').val();
        const stripeForm = new StripeForm(stripeConnectId);
        const $button = $('.p-button--choose-package-submit');

        function submitStripeForm(clientSecret) {
          const $form = $('.choose-package__form');

          stripeForm.submitWithPaymentIntent(clientSecret).then((result) => {
            if (result.error) {
              $button.removeClass('button-loading').prop('disabled', false);
              alert(`An error occured: ${result.error.message}`);
            } else {
              const id = $form.find('#package_id').val();
              const formData = $form.serializeArray();
              formData.push({ name: 'payment_intent_id', value: result.paymentIntent.id });
              formData.push({ name: 'payment_method', value: 'credit_card' });

              const processPaymentURL = `/design-packages/${id}/xhr_process_design_package_payment`;
              $.post(processPaymentURL, $.param(formData), function (data) {
                if (data.success) {
                  const projectIds = data.project_ids.join(',');
                  let url;
                  if (data.questionnaire_enabled) {
                    url = `/projects/${data.project_ids[0]}/edit?project_ids=${projectIds}`;
                  } else {
                    url = '/projects';
                  }
                  window.location.href = url;
                } else {
                  alert(`An error occured: ${data.error_message}`);
                  $button.removeClass('button-loading').prop('disabled', false);
                }
              });
            }
          });
        }

        $(document).on('submit', '.choose-package__form', function (e) {
          e.preventDefault();

          const $form = $(this);
          $button.addClass('button-loading').prop('disabled', true);

          // registration
          if ($('.choose-package__user-register:visible').length) {
            const teamId = $('meta[name=team-id]').attr('content');
            const name = $('#register-name').val();
            const email = $('#register-email').val();
            const phone = $('#register-phone').val();
            const password = $('#register-password').val();

            let error = '';
            $form.find('label.form-error').hide();

            error = UserValidator.validateName(name);
            $('label.form-error[for=register-name]')
              .text(error)
              .css('display', error === '' ? 'none' : 'block');

            error = UserValidator.validateEmail(email);
            $('label.form-error[for=register-email]')
              .text(error)
              .css('display', error === '' ? 'none' : 'block');

            error = UserValidator.validatePassword(password);
            $('label.form-error[for=register-password]')
              .text(error)
              .css('display', error === '' ? 'none' : 'block');

            if ($('label.form-error:visible').length) {
              $('label.form-error:visible:first').focus();
              $button.removeClass('button-loading').prop('disabled', false);
              return;
            }

            $.ajax({
              type: 'POST',
              url: '/register',
              data: {
                authenticity_token: $('meta[name=csrf-token]').attr('content'),
                user: {
                  name,
                  email,
                  phone,
                  password,
                  password_confirmation: password,
                  role: 'client',
                  team_id: teamId,
                },
              },
              dataType: 'json',
              success(data) {
                $('.choose-package__user-register, .choose-package__user-login').remove();
                generatePaymentIntentAndSubmit();
              },
              error(data) {
                $button.removeClass('button-loading').prop('disabled', false);
                if (data.responseJSON.errors['email']) {
                  const errorHtml =
                    '<span>You already have an account. <a href="#" data-kind="login" class="choose-package__tab-link">Login here instead</a></span>';
                  $('label.form-error[for=register-email]').html(errorHtml).css('display', 'block');
                } else {
                  alert('Could not create new account. Your card was not charged.');
                }
              },
            });

            // login
          } else if ($('.choose-package__user-login:visible').length) {
            const email = $('#login-email').val();
            const password = $('#login-password').val();

            let error = '';
            $form.find('label.form-error').hide();

            error = UserValidator.validateEmail(email);
            $('label.form-error[for=login-email]')
              .text(error)
              .css('display', error === '' ? 'none' : 'block');

            error = UserValidator.validatePassword(password);
            $('label.form-error[for=login-password]')
              .text(error)
              .css('display', error === '' ? 'none' : 'block');

            if ($('label.form-error:visible').length) {
              $('label.form-error:visible:first').focus();
              $button.removeClass('button-loading').prop('disabled', false);
              return;
            }

            $.ajax({
              type: 'POST',
              url: '/login',
              data: {
                authenticity_token: $('meta[name=csrf-token]').attr('content'),
                user: {
                  email,
                  password,
                },
              },
              dataType: 'json',
              success(data) {
                $('.choose-pachage__user-register, .choose-package__user-login').remove();
                generatePaymentIntentAndSubmit();
              },
              error(data) {
                $('label.form-error[for=login-email]')
                  .text('Invalid email or password')
                  .css('display', 'block');
                $('label.form-error:visible:first').focus();
                $button.removeClass('button-loading').prop('disabled', false);
              },
            });

            return false;
          } else {
            generatePaymentIntentAndSubmit();
          }
        });

        function generatePaymentIntentAndSubmit() {
          const $form = $('.choose-package__form');
          const id = $form.find('#package_id').val();
          const formData = $form.serializeArray();

          const paymentIntentURL = `/design-packages/${id}/xhr_generate_design_package_payment_intent`;
          $.post(paymentIntentURL, $.param(formData), function (data) {
            if (data.success) {
              submitStripeForm(data.client_secret);
            } else {
              alert(`An error occured: ${data.error_message}`);
              $button.removeClass('button-loading').prop('disabled', false);
            }
          });
        }
      });

      $(document).on($.modal.CLOSE, '.modal--choose-package', () => {
        $('.modal--choose-package').remove();
      });
    }
    $(document).on('focus', '.design-package__list-item--edit', (e) => {
      $(e.target)
        .closest('.design-package__edit-list')
        .addClass('design-package__edit-list--active');
    });

    $(document).on('blur', '.design-package__list-item--edit', (e) => {
      $(e.target)
        .closest('.design-package__edit-list')
        .removeClass('design-package__edit-list--active');
    });
  });
});
